import React, { createContext, useContext, useEffect, useState } from 'react'
import {
    View,
    ScrollView,
    Text,
    TouchableOpacity,
    Image,
    Dimensions,
    Platform,
} from 'react-native'
import { FlashList } from '@shopify/flash-list'
import styles from './TriviaRankingListStyles'
import theme from '../../../theme'
import { Loader } from '../customUtils/Components/Loader'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { avatarPlaceholder } from '../customUtils/Constants'
import { Feather } from '@expo/vector-icons'
import { LinearGradient } from 'expo-linear-gradient'
import { triviaMainColor, TriviaTheme } from '../../../themeConstants'
import { ImageBackground } from 'expo-image'
import { useIsMobile } from '@/redux/zustand/useDimensionStore'
let width = Dimensions.get('window').width
const isWeb = Platform.OS === 'web'
export const TriviaRankingList = ({ ranking, hasTrivias }) => {
    const { languageFile } = getLanguage()
    const [loading, setLoading] = useState(false)
    const emptyRanking = { full_name: 'Vacante', user_avatar: avatarPlaceholder }
    const isMobile = useIsMobile()
    let first_place = ranking[0]
        ? {
              full_name: ranking[0].user_name + ' ' + ranking[0].user_last_name,
              user_avatar: ranking[0].user_avatar,
              points: ranking[0].score,
          }
        : emptyRanking
    let second_place = ranking[1]
        ? {
              full_name: ranking[1].user_name + ' ' + ranking[1].user_last_name,
              user_avatar: ranking[1].user_avatar,
              points: ranking[1].score,
          }
        : emptyRanking
    let third_place = ranking[2]
        ? {
              full_name: ranking[2].user_name + ' ' + ranking[2].user_last_name,
              user_avatar: ranking[2].user_avatar,
              points: ranking[2].score,
          }
        : emptyRanking

    let noRankingTitle = !hasTrivias
        ? languageFile.no_ranking_no_trivia_title
        : ranking.length === 0
          ? languageFile.no_ranking_available_title
          : languageFile.no_podium_title
    let noRankingDesc = !hasTrivias
        ? languageFile.no_ranking_no_trivia_text
        : ranking.length === 0
          ? languageFile.no_ranking_text
          : languageFile.no_podium_text
    return loading ? (
        <Loader />
    ) : (
        <View style={[{ flex: 1, alignItems: 'center' }]}>
            <ScrollView
                style={[
                    { flex: 1, width: '100%', height: '100%' },
                    !isMobile && { maxWidth: 952 },
                ]}
            >
                <TriviaPodium
                    first_place={first_place}
                    second_place={second_place}
                    third_place={third_place}
                />
                <View
                    showsVerticalScrollIndicator={true}
                    style={{ zIndex: 0, paddingTop: 32 }}
                >
                    {ranking.length > 0 &&
                        ranking
                            .slice(3)
                            .map((rank, index) => (
                                <TriviaRankingItem key={index + 3} item={rank} />
                            ))}
                    {ranking.length <= 3 && (
                        <View
                            style={[
                                styles.containerNoRanking,
                                { marginHorizontal: 15 },
                            ]}
                        >
                            <Text style={styles.title2}>{noRankingTitle}</Text>
                            <Text style={[styles.description2, { marginTop: 4 }]}>
                                {noRankingDesc}
                            </Text>
                        </View>
                    )}
                </View>
            </ScrollView>
        </View>
    )
}
const TriviaRankingItem = ({ item }) => {
    const { languageFile } = getLanguage()
    const [image, setImage] = useState(
        item.user_avatar ? item.user_avatar : avatarPlaceholder,
    )
    const isMobile = useIsMobile()
    return (
        <View>
            <TouchableOpacity style={[styles.triviaItem, { pointerEvents: 'none' }]}>
                <Text
                    style={[
                        styles.triviaName,
                        {
                            marginEnd: 12,
                            color: TriviaTheme.rankingPositionTextColor,
                            fontSize: 16,
                        },
                    ]}
                >
                    {item.position + '°'}
                </Text>

                <Image
                    style={styles.triviaImage}
                    source={{ uri: image }}
                    onError={() => {
                        setImage(avatarPlaceholder)
                    }}
                />
                <View
                    style={{
                        flex: 1,
                        flexDirection: 'column',
                        justifyContent: 'center',
                    }}
                >
                    <Text
                        style={[
                            styles.triviaDescription,
                            {
                                marginEnd: 12,
                                color: TriviaTheme.rankingUserTextColor,
                            },
                        ]}
                    >
                        {item.user_name + ' ' + item.user_last_name}
                    </Text>
                </View>

                <View
                    style={[
                        styles.triviaPointsContainer,
                        !isMobile && { paddingHorizontal: 14 },
                    ]}
                >
                    <Text style={styles.podium_user_points_text}>{item.score}</Text>
                    <Text style={styles.podium_user_points_Pts}> pts</Text>
                </View>
            </TouchableOpacity>
            <View style={styles.dividerHorizontalLine}></View>
        </View>
    )
}

export const TriviaPodium = ({ first_place, second_place, third_place }) => {
    function validateImage(image) {
        if (image == undefined || image == null || image == '') {
            return avatarPlaceholder
        }
        return image
    }
    const [first_place_image, setFirstPlaceImage] = useState(
        validateImage(first_place.user_avatar),
    )
    const [second_place_image, setSecondPlaceImage] = useState(
        validateImage(second_place.user_avatar),
    )
    const [third_place_image, setThirdPlaceImage] = useState(
        validateImage(third_place.user_avatar),
    )
    const isMobile = useIsMobile()
    return (
        <View
            style={[
                {
                    backgroundColor: TriviaTheme.tabsUnselectedColor,
                    flex: 1,
                    minHeight: 284,
                    borderRadius: 16,
                    zIndex: 1,
                },
                isMobile && { marginHorizontal: 12 },
            ]}
        >
            <ImageBackground
                source={require('../../../assets/trivia/triviaPodiumBackgroundWeb.png')}
                style={{ flex: 1 }}
                resizeMethod='resize'
            >
                <Image
                    source={require('../../../assets/trivia/triviaPodiumRankingWeb.png')}
                    style={{
                        width: 252,
                        height: 180,
                        resizeMode: 'cover',
                        position: 'absolute',
                        bottom: -30,
                        alignSelf: 'center',
                    }}
                    resizeMethod='resize'
                />
                <View
                    style={{
                        flexDirection: 'row',
                        position: 'absolute',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                        height: '100%',
                        paddingBottom: 40,
                        gap: 15,
                    }}
                >
                    <View style={{ alignContent: 'center', paddingBottom: 10 }}>
                        {second_place && (
                            <PodiumUser
                                place={2}
                                full_name={second_place.full_name}
                                user_avatar={second_place_image}
                                points={second_place.points}
                                currentUser={false}
                            />
                        )}
                    </View>
                    <View style={{ alignContent: 'center', paddingBottom: 90 }}>
                        {first_place && (
                            <PodiumUser
                                place={1}
                                full_name={first_place.full_name}
                                user_avatar={first_place_image}
                                points={first_place.points}
                                currentUser={false}
                            />
                        )}
                    </View>
                    <View style={{ alignContent: 'center', paddingTop: 50 }}>
                        {third_place && (
                            <PodiumUser
                                place={3}
                                full_name={third_place.full_name}
                                user_avatar={third_place_image}
                                points={third_place.points}
                                currentUser={false}
                            />
                        )}
                    </View>
                </View>
            </ImageBackground>
        </View>
    )
}

export const PodiumUser = ({
    place,
    full_name,
    user_avatar,
    points = null,
    currentUser = false,
}) => {
    return (
        <View style={{ width: 100, alignSelf: 'center', alignItems: 'center' }}>
            <Text
                style={{
                    fontWeight: 'bold',
                    color: triviaMainColor,
                    marginBottom: 9,
                    fontSize: 14,
                }}
                numberOfLines={1}
            >
                {currentUser ? '¡Estas aquí!' : ' '}
            </Text>

            <Image
                source={{ uri: user_avatar }}
                style={[
                    styles.podium_avatar,
                    { width: 60, height: 60, borderRadius: 30 },
                ]}
                resizeMethod='resize'
                resizeMode='contain'
            />
            <Text
                style={{
                    fontWeight: 'bold',
                    color: TriviaTheme.podiumUserTextcolor,
                    marginVertical: 5,
                    fontSize: 13,
                }}
                ellipsizeMode='tail'
                numberOfLines={1}
            >
                {full_name}
            </Text>
            {points && (
                <View
                    style={[
                        styles.podium_user_points_container,
                        { paddingHorizontal: 14 },
                    ]}
                >
                    <Text style={styles.podium_user_points_text}>{points}</Text>
                    <Text style={styles.podium_user_points_Pts}> pts</Text>
                </View>
            )}
        </View>
    )
}
